import { Component } from 'react'

import { IProps } from './types'

export default abstract class SearchStateManager<P> extends Component<P & IProps> {
  constructor(props: any) {
    super(props)
    this.selectItem = this.selectItem.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleHover = this.handleHover.bind(this)
    this.updateSearchValue = this.updateSearchValue.bind(this)
  }

  // SearchState ---
  selectItem(index: number | null) {
    const {
      name,
      searchValue,
      matchingOptions,
      setSearchValue,
      setHighlightedIndex,
      closeSearchMenu
    } = this.props
    const valueNotChanged = searchValue === null
    const trimmedValue = (searchValue && searchValue.trim()) || ''
    const valueNotBlank = trimmedValue.length > 0

    let highlightedOption = null

    if (index !== null && index > -1) {
      highlightedOption = matchingOptions[index] || null
    }

    // An option is highlighted
    // (eg. Start typing then select an option or open menu and select an option
    // or open menu and select an option (when previously blank))
    if ((valueNotChanged || valueNotBlank) && highlightedOption) {
      // @ts-ignore
      setSearchValue(name, highlightedOption.name)
      setHighlightedIndex(name, 0) // option should now be first in list (as it's an exact match)
      // @ts-ignore
      this.props.onChange(highlightedOption.id)

      // Value is not empty (and no option highlighted)
      // (eg. Start typing then tab out with no matching options)
    } else if (valueNotBlank) {
      this.props.onChange(null)

      // Value is empty
    } else if (trimmedValue == '') {
      setSearchValue(name, null)
      this.props.onChange(null)
    }
    closeSearchMenu(name)
  }

  handleKeyDown(e: any) {
    const { name, highlightedIndex, matchingOptions, setHighlightedIndex } = this.props
    const matchCount = matchingOptions.length
    if (e.keyCode === 13) {
      e.preventDefault()
      this.selectItem(highlightedIndex || 0)
    } else if (e.ctrlKey) {
      e.preventDefault()
      // ctrl-j
      if (e.keyCode === 80 && highlightedIndex > 0) {
        setHighlightedIndex(name, highlightedIndex - 1)
        // ctrl-n
      } else if (e.keyCode === 78 && highlightedIndex < matchCount - 1) {
        setHighlightedIndex(name, highlightedIndex + 1)
      }
      // up arrow
    } else if (e.keyCode === 38 && highlightedIndex > 0) {
      e.preventDefault()
      setHighlightedIndex(name, highlightedIndex - 1)
      // down arrow
    } else if (e.keyCode === 40 && highlightedIndex < matchCount - 1) {
      e.preventDefault()
      setHighlightedIndex(name, highlightedIndex + 1)
    }
  }

  handleClick = (index: number) => {
    this.selectItem(index)
  }

  handleHover(index: number) {
    const { name, setHighlightedIndex } = this.props
    setHighlightedIndex(name, index)
  }

  handleFocus() {
    const { name, onFocus, openSearchMenu } = this.props
    openSearchMenu(name)
    onFocus()
  }

  handleBlur(e: any) {
    const { name, onBlur, highlightedIndex, closeSearchMenu } = this.props
    closeSearchMenu(name)
    if (typeof onBlur === 'function') {
      this.props.onBlur(e)
    }
    this.selectItem(highlightedIndex)
  }

  handleChange(e: any) {
    const { name, onSearch, searchValue, setHighlightedIndex } = this.props
    const { value } = e.target
    this.updateSearchValue(value)
    if (value && searchValue && value.length < searchValue.length) {
      setHighlightedIndex(name, 0)
    }
    if (onSearch) {
      onSearch(name, value)
    }
  }

  updateSearchValue(searchValue: string) {
    const { name, setSearchValue } = this.props
    setSearchValue(name, searchValue)
  }
}
